<template>
  <div class="base-input input-style">
    <v-text-field
      :type="type"
      outlined
      :placeholder="placeholder"
      dense
      height="36px"
      max-height="36px"
      max
      :rules="rules"
      :hide-details="hideDetails"
      :value="value"
      :disabled="disabled"
      @input="$emit('input', $event)"
      @keyup.enter="$emit('enter')"
      :readonly="readOnly"
      :prepend-inner-icon="type == 'price' ? 'mdi-currency-try' : ''"
      :append-icon="isSearch ? 'mdi-magnify' : ''"
    >
    </v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      validator: () => true,
    },
    type: {
      type: String,
      default: "text",
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [(v) => !!v || "this field is require"],
    },
  },
};
</script>

<style lang="scss">
.input-style {
  .v-input__slot {
    fieldset {
      border: 0px !important;
      background: #a7a7a7ab;
    }

    .v-input__append-inner {
      margin-top: 5px !important;
    }
    .v-text-field__slot {
      height: 35px !important;
    }
  }
  .error--text {
    .v-input__slot {
      fieldset {
        height: 40px !important;
        border: 1px solid #e44358 !important;
      }
    }
  }
}
.v-input__icon--prepend-inner{
  margin-top: 0px !important; 
}
</style>
